import React, { useEffect, useState, useRef } from 'react';
import {
  external1,
  //  account_step, account_step2, account_step3, account_step4,
  card_vector, carduser1, carduser2, carduser3, onestart, start, circletik, clients, workright,
  billing, about_left_img, based, np, academic, accounts, dental, consulting, emr, finacess, severices, dottesti, rcmapart,
  mental,
  twoperson,
} from '../../../assets/images';
import { Accordion, Button, Card, Modal, Container, Col, Row, } from 'react-bootstrap';
import 'uikit/dist/css/uikit.min.css';
import 'uikit/dist/js/uikit.min.js';
import 'uikit/dist/js/uikit-icons.min.js'; // Optional if you want to use icons
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { getContactApiUrl } from '../../../config/api';
import { FaPlus, FaMinus } from "react-icons/fa";
const testimonials = [
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
  {
    title: 'Exceptional Service and Accuracy',
    quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
    name: "Wade Warren",
    role: "",
    rating: 4.3,
    img: carduser1, // You can replace this with actual images
  },
  {
    title: 'Efficient and Reliable',
    quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
    name: "Sophie Reynolds",
    role: "",
    rating: 4.2,
    img: carduser2,
  },
  {
    title: 'Outstanding Denials Management',
    quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
    name: "David Mitchell",
    role: "",
    rating: 4.1,
    img: carduser3,
  },
];

const practiceSettings = [
  {
    number: "01",
    title: "Clinic or Health System-Affiliated ",
    description:
      "Manage complex mental health billing across large healthcare systems with seamless system integrations, multi-specialty workflows, and expert support to overcome revenue cycle challenges. ",
    icon: based, // Replace with correct path
    alt: "Hospital icon"
  },
  {
    number: "02",
    title: "Private Practice ",
    description:
      "Take full control of your revenue with private practice billing services that reduce administrative burdens, minimize claim denials, and free you to focus on delivering quality client care. ",
    icon: np, // Replace with correct path
    alt: "Independent practice icon"
  },
  {
    number: "03",
    title: "University-Affiliated or Academic Settings ",
    description:
      "Overcome the challenges of academic billing with customized RCM solutions designed for both clinical and research environments, ensuring accurate reporting and financial transparency. ",
    icon: academic, // Replace with correct path
    alt: "University icon"
  }
];
const familyMedicineServices = [
  {
    title: "Accounts Receivable",
    description:
      "Improve cash flow with specialized A/R management that stabilizes revenue and accelerates payments for mental health practices.",
    icon: accounts, // Replace with actual icon path
    alt: "Accounts Receivable Icon"
  },
  {
    title: "Collections & Denial Management",
    description:
      "Reduce claim denials and maximize reimbursements with expert collections management tailored for mental health providers.",
    icon: dental,
    alt: "Collections & Denial Icon"
  },
  {
    title: "Consulting & Practice Optimization",
    description:
      "Work with mental health RCM specialists to identify inefficiencies, optimize billing processes, and grow your practice.",
    icon: consulting,
    alt: "Consulting Icon"
  },
  {
    title: "EHR & System Integration",
    description:
      "Enhance operational efficiency with seamless EMR and system integration, minimizing administrative burdens and improving data accuracy.",
    icon: emr,
    alt: "EHR Integration Icon"
  },
  {
    title: "Financial Analysis & Reporting",
    description:
      "Gain actionable insights and financial clarity with data-driven performance analysis and customized reporting.",
    icon: finacess,
    alt: "Financial Analysis Icon"
  },
  {
    title: "Specialized Medical Billing Services",
    description:
      "Maximize revenue with technology-driven mental health billing services and expert support designed to simplify complex billing.",
    icon: severices,
    alt: "Medical Billing Icon"
  }
];


const MentalHealth = () => {
  const sectionRefs = useRef([]);
  const containerRef = useRef();

  const [animatedSections, setAnimatedSections] = useState(new Set());

  // Google Analytics tracking function
  const trackEvent = (eventName, category = 'MentalHealth', label = '') => {
    if (window.gtag) {
      window.gtag('event', eventName, {
        event_category: category,
        event_label: label,
      });
    }
  };

  // Handle service card clicks
  const handleServiceClick = (serviceName) => {
    trackEvent('service_card_click', 'Services', serviceName);
  };

  // Handle practice setting card clicks
  const handlePracticeSettingClick = (settingName) => {
    trackEvent('practice_setting_click', 'Practice Settings', settingName);
  };

  // Enhanced CTA button click handler
  const handleCTAClick = (buttonLocation) => {
    trackEvent('cta_button_click', 'CTA', buttonLocation);
    handleShow();
  };
  const CARD_WIDTH =
    window.innerWidth < 768
      ? 335
      : window.innerWidth < 1024
        ? 350
        : window.innerWidth < 1200
          ? 400
          : window.innerWidth < 1500
            ? 450
            : window.innerWidth < 1700
              ? 500
              : window.innerWidth < 1800
                ? 568
                : 625;
  const infiniteTestimonials = [...testimonials, ...testimonials, ...testimonials];

  const groupedTestimonials = [];
  for (let i = 0; i < testimonials.length; i += 3) {
    groupedTestimonials.push(testimonials.slice(i, i + 3));
  }

  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(3.5);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const updateVisibleCards = () => {
    if (window.innerWidth < 1024) {
      setVisibleCards(1);
    } else {
      setVisibleCards(3.5);
    }
  };

  const [activeKey, setActiveKey] = useState("0");

  const toggleKey = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };
  const animatedOnce = useRef(new Set());

  useEffect(() => {
    updateVisibleCards();
    window.addEventListener('resize', updateVisibleCards);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = entry.target.dataset.sectionIndex;
          if (index && entry.isIntersecting && !animatedOnce.current.has(parseInt(index))) {
            setAnimatedSections(prev => new Set([...prev, parseInt(index)]));
            animatedOnce.current.add(parseInt(index));
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      window.removeEventListener('resize', updateVisibleCards);
      observer.disconnect();
    };
  }, []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < testimonials.length - visibleCards ? prevIndex + 1 : prevIndex
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleClose = () => {
    setShowModal(false);
    setIsSubmitted(false);
  };
  const handleShow = () => setShowModal(true);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const handleAccordionToggle = (eventKey) => {
    setActiveAccordion(prev => (prev === eventKey ? null : eventKey));
  }
  // const getImageToShow = () => {
  //   switch (activeAccordion) {
  //     case "0":
  //       return account_step2;
  //     case "1":
  //       return account_step3;
  //     case "2":
  //       return account_step4;
  //     case "3":
  //       return account_step5;
  //     default:
  //       return account_step;
  //   }
  // };
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onChange", // Enables real-time validation
  });
  const [activeKey2, setActiveKey2] = useState("0");

  const toggleKey2 = (key) => {
    setActiveKey2(activeKey2 === key ? null : key);
  };
  const [navbarColor, setNavbarColor] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const response = await axios.post(getContactApiUrl(), {
        fullName: data.fullName,
        email: data.email,
        subject: data.subject || 'Contact Form Submission',
        message: data.message,
      });
      if (response.data.success) {
        setIsSubmitted(true);
        reset();
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);

    const changeNavbarColor = () => {
      if (window.scrollY >= 80) {
        setNavbarColor(true);
      } else {
        setNavbarColor(false);
      }
    };
    window.addEventListener('scroll', changeNavbarColor);
    return () => {
      window.removeEventListener('scroll', changeNavbarColor);
    };
  }, []);
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const maxIndex = testimonials.length - Math.floor(visibleCards);
        return prevIndex >= maxIndex ? 0 : prevIndex + 1;
      });
    }, 2500); // Change slide every 3 seconds

    return () => clearInterval(interval);
  }, [isAutoPlaying, visibleCards]);
  return (
    <>
      <style>{`
        @media (min-width: 768px) {
          .animate-section[data-section-index="0"] {
            opacity: 0;
            transform: translateY(50px) scale(0.95);
            transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          }
          .animate-section[data-section-index="0"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="1"] {
            opacity: 0;
            transform: translateX(-40px) rotateY(5deg);
            transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s;
          }
          .animate-section[data-section-index="1"].visible {
            opacity: 1;
            transform: translateX(0) rotateY(0deg);
          }
          .animate-section[data-section-index="2"] {
            opacity: 0;
            transform: translateY(60px) scale(0.9);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s;
          }
          .animate-section[data-section-index="2"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="3"] {
            opacity: 0;
            transform: translateY(70px) scale(0.92);
            transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.4s;
          }
          .animate-section[data-section-index="3"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="4"] {
            opacity: 0;
            transform: translateY(55px) scale(0.96);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s;
          }
          .animate-section[data-section-index="4"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="5"] {
            opacity: 0;
            transform: translateX(35px) rotateY(-3deg);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.6s;
          }
          .animate-section[data-section-index="5"].visible {
            opacity: 1;
            transform: translateX(0) rotateY(0deg);
          }
          .animate-section[data-section-index="6"] {
            opacity: 0;
            transform: translateY(45px) scale(0.97);
            transition: all 0.5s ease-out 0.7s;
          }
          .animate-section[data-section-index="6"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="7"] {
            opacity: 0;
            transform: translateX(-30px) rotateY(4deg);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.8s;
          }
          .animate-section[data-section-index="7"].visible {
            opacity: 1;
            transform: translateX(0) rotateY(0deg);
          }
          .animate-section[data-section-index="8"] {
            opacity: 0;
            transform: translateY(40px) scale(0.98);
            transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.9s;
          }
          .animate-section[data-section-index="8"].visible {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          .animate-section[data-section-index="9"] {
            opacity: 0;
            transform: translateX(25px) rotateY(-2deg);
            transition: all 0.5s ease-in-out 0.7s;
          }
          .animate-section[data-section-index="9"].visible {
            opacity: 1;
            transform: translateX(0) rotateY(0deg);
          }
        }
        @media (max-width: 767px) {
          .animate-section[data-section-index="0"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease;
          }
          .animate-section[data-section-index="0"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="1"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.1s;
          }
          .animate-section[data-section-index="1"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="2"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.2s;
          }
          .animate-section[data-section-index="2"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="3"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.3s;
          }
          .animate-section[data-section-index="3"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="4"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.4s;
          }
          .animate-section[data-section-index="4"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="5"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.5s;
          }
          .animate-section[data-section-index="5"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="6"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.6s;
          }
          .animate-section[data-section-index="6"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="7"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.7s;
          }
          .animate-section[data-section-index="7"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="8"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.8s;
          }
          .animate-section[data-section-index="8"].visible {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-section[data-section-index="9"] {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.6s ease 0.9s;
          }
          .animate-section[data-section-index="9"].visible {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .btn {
          transition: all 0.3s ease;
          transform: translateY(0);
        }
        .btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(226, 114, 57, 0.4);
        }
        .card {
          transition: all 0.3s ease;
        }
        .card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
        }
        .services-hover-effect {
          transition: all 0.3s ease;
        }
        .services-hover-effect:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
        }
      `}</style>
      <section className="hero-section text-center">
        <div
          className={`about_bg d-flex align-items-center justify-content-center animate-section ${animatedSections.has(0) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[0] = el}
          data-section-index="0"
        >
          <div className="row mx-auto mt-lg-5 mt-5">
            <div className="col-12 text-center mt-lg-5">
              <h1 className="about_font text-white fw-bold" >
                Streamlined Revenue Cycle Management<br /> for Mental Health Practices
              </h1>
              <p className='mb-0 text-white add_para_font fw-medium'>
                We streamline{" "}
                <a
                  href="https://probillrcm.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "inherit", textDecoration: "none", fontWeight: "bold" }}
                >
                  mental health billing
                </a>{" "}
                with tailored RCM services reducing claim denials, maximizing
                <br /> reimbursements, and providing expert financial consulting.
              </p>
            </div>
            <div className='col-12 d-flex align-items-center justify-content-center mt-md-5 mt-3'>
              <button
                className="btn add_padding_font"
                onClick={() => handleCTAClick('hero_section')} type="button"
                style={{
                  background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                  color: "white",
                  borderRadius: "12px",
                  padding: "12px 40px",
                  border: "none",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Let’s Connect                           </button>
            </div>
          </div>
        </div>
        <div
          className={`boost_main_clie position-relative animate-section ${animatedSections.has(1) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[1] = el}
          data-section-index="1"
        >
          <div className='container pt-lg-4'>
            <div className='row py-md-5 py-4'>
              <div className='col-lg-6'>
                <div className='row mx-auto'>
                  <div className='col-12'>
                    <img src={mental} alt='Mental health billing services' className='twogroup_imgs' />
                  </div>
                </div>
              </div>
              <div className='col-lg-6'>
                <div className='row'>

                  <div className='col-12 d-flex align-items-start text-start pe-0 justify-content-start mt-3 mt-md-0'>
                    <h2 className='mb-0 d-flex align-items-center justify-content-start add_font_head fw-semibold'>
                      Mental Health Billing, RCM, and Consulting with a Personalized Approach
                    </h2>
                  </div>
                  <div className='col-12 d-flex align-items-start text-start pe-0 justify-content-start mt-3'>
                    <h3 className='mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font'>
                      Enhancing Revenue and Financial Clarity                                    </h3>
                  </div>
                  <div className='col-12 d-flex align-items-start justify-content-start mt-md-3 mb-md-3 mt-3'>
                    <p className='mb-0 d-flex align-items-start justify-content-start text_justify_para'>
                      ProBill RCM experts leverage advanced RCM tools, billing analytics, and proven strategies to help mental health providers reduce claim denials, optimize reimbursements, and enhance revenue flow. With deep expertise in therapy, psychiatry, and counseling billing, Probill RCM delivers end-to-end financial clarity and reliable practice management.                   </p>
                  </div>
                  <div className='col-12 d-flex align-items-start text-start pe-0 justify-content-start mt-md-0 mt-3 pe-0 mb-0'>
                    <h3 className='mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font'>
                      Our Mental Health Billing & RCM Services Include:                                                                       </h3>
                  </div>

                  <div className='col-12  mt-md-4 mb-md-4 mt-3'>
                    <p className='mb-3 d-flex align-items-start justify-content-start text-start'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Specialized Billing & Coding for therapy, psychiatry, counseling, and telehealth, ensuring accuracy and compliance.                                </p>
                    <p className='mb-3 d-flex align-items-start justify-content-start text-start'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Comprehensive Revenue Cycle Management to reduce claim denials, accelerate reimbursements, and boost cash flow.                                     </p>

                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className='boost_main_client boost_main_client_two position-absolute'>
            <img src={clients} alt='' />
          </div>
        </div>
        {/* <div
          className={`container mt-0 animate-section ${animatedSections.has(2) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[2] = el}
          data-section-index="2"
        >
          <div className='row mx-auto'>
            <div className='col-12 add_border_bottom pb-4 text-md-start text-center px-0'>
              <h3 className='mb-0 add_driving_font fw-semibold'>
                Mental Health <span className='add_grident_font'> Expertise</span>
              </h3>
            </div>
            <div className='col-12 mb-lg-4'>
              <div className='row'>
                <div className='col-md-3 col-6'>
                  <div className='row'>
                    <div className='col-12 pt-4 pb-md-5 pb-0'>
                      <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                        15+
                      </h3>
                      <p className='text-md-start text-center mt-0 add_font_another fw-medium'>
                        Years of Experience
                      </p>
                    </div>
                  </div>
                </div>
                <div className='col-md-3 col-6'>
                  <div className='row'>
                    <div className='col-12 pt-4 pb-md-5 pb-0'>
                      <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                        2000+
                      </h3>
                      <p className='text-md-start text-center mt-0 add_font_another fw-medium'>
                        Team Members
                      </p>
                    </div>
                  </div>
                </div>
                <div className='col-md-3 col-6'>
                  <div className='row'>
                    <div className='col-12 pt-md-4 pt-0 pb-md-5 pb-4'>
                      <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                        $2.7B+
                      </h3>
                      <p className='text-md-start text-center mt-0 add_font_another fw-medium'>
                        In Payments
                      </p>
                    </div>
                  </div>
                </div>
                <div className='col-md-3 col-6'>
                  <div className='row'>
                    <div className='col-12 pt-md-4 pt-0 pb-md-5 pb-4'>
                      <h3 className=' text-md-start text-center add_grident_font add_head_font_year fw-semibold mb-0'>
                        $20B+
                      </h3>
                      <p className='text-md-start text-center mt-0 add_font_another fw-medium'>
                        In Charges
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div
          className={`bg_blue_vertical py-5 mx-auto d-flex align-items-center justify-content-center animate-section ${animatedSections.has(3) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[3] = el}
          data-section-index="3"
        >
          <div className='container py-lg-5'>
            <div className='row'>
              <div className='col-12 '>
                <div className='row border-bottom pb-md-5 pb-4'>
                  <div className='col-md-6 col-12'>
                    <h2 class="mb-0 d-flex align-items-center justify-content-start add_font_head fw-semibold text-white text-start">Mental Health Touch™: Simplifying Clinical Record-Keeping </h2>
                  </div>
                  <div className='col-md-6 col-12 mt-3 mt-md-0'>
                    <p class="mb-0 d-flex align-items-start justify-content-start text-start text-white">Take the stress out of paperwork with Mental Health Touch™, a smart, automated solution built for therapists, counselors, psychiatrists, and behavioral health providers. It helps you capture and manage real-time clinical data securely, streamline your documentation process, and focus more on what matters most delivering exceptional patient care. </p>
                  </div>
                </div>
              </div>
              <div className='col-12 pt-md-0 pt-4'>
                <div className='row'>
                  {/* <div className='col-12 d-flex align-items-start text-start pe-0 justify-content-start mt-0 pe-0 mb-3 mb-md-0'>
                    <h6 className='mb-0 d-flex align-items-center justify-content-start fw-semibold add_subheading_font text-white'>
                      Core Features of Mental Health Touch™                                                                      </h6>
                  </div> */}
                  <div className='col-md-6 col-12  mt-md-5 mb-md-4'>
                    <p className='mb-md-4 mb-3 d-flex align-items-start justify-content-start text-start text-white'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Secure Access Anytime, Anywhere - Even works offline for uninterrupted clinical operations.
                    </p>
                    <p className='mb-md-4 mb-3 d-flex align-items-start justify-content-start text-start text-white'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Streamlined Intake & Scheduling - Connect patient registration, assessments, and treatment plans seamlessly.                  </p>
                    <p className='mb-md-0 mb-3 d-flex align-items-start justify-content-start text-start text-white'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Customizable Platform - Perfect for solo practitioners, group practices, or large mental health clinics.
                    </p>
                  </div>
                  <div className='col-md-6 col-12  mt-md-5 mb-md-4'>
                    <p className='mb-md-4 mb-3 d-flex align-items-start justify-content-start text-start text-white'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Automated Session Data Capture - Reduce manual entry with real-time clinical progress notes.                  </p>
                    <p className='mb-md-4 mb-3 d-flex align-items-start justify-content-start text-start text-white'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Fast Documentation Transfer - Send complete patient documentation directly to your billing/RCM team.                  </p>
                    <p className='mb-0 d-flex align-items-start justify-content-start text-start text-white'>
                      <img src={circletik} alt='' className='circle_tik_img me-3' />
                      Insightful Dashboards - Monitor clinical outcomes, operational efficiency, and financial performance in one place.                                                        </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`about-bg-img p-lg-1 mt-lg-0 position-relative animate-section ${animatedSections.has(4) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[4] = el}
          data-section-index="4"
        >
          <div class="boost_main_client_right boost_main_client_right_tranform_text2 position-absolute d-md-flex d-none">
            <img src="/static/media/workright.9f2dd025b6ec7c8f6511.webp" alt="" /></div>
          <div className="about-bg-img2 py-md-5 py-0">
            <div className="container p-lg-2 mb-lg-4  mt-4 mt-lg-4">
              <div className="row">
                <div className="col-12 col-lg-6 pe-5">
                  <img src={twoperson} className='img-fluid mt-1 w-100 about-left-img' alt="behavioral & mental health billing services" />
                </div>
                <div className="col-12 col-lg-6 my-auto ">
                  <div className="div text-start mt-3 mt-md-0">
                    <div className='col-12'>
                      <h2 class="mb-0 d-flex align-items-center justify-content-start add_font_head fw-semibold text-dark text-start">Why Mental Health Practices Need a Billing and RCM Partner</h2>
                    </div>
                    <div className='col-12 mt-3'>
                      <p class="mb-0 d-flex align-items-start justify-content-start text-start about-first-desc">Outsourcing billing and revenue cycle management offers clear advantages for mental health providers:</p>
                    </div>
                    <div className="d-flex mt-lg-4 mt-3">
                      <div className='number-bg-img one p-lg-3 mt-lg-0 mt-0 text-lg-center'></div>
                      <div className="div d-flex align-items-center">
                        <p className='m-0 mt-lg-2 about-first-desc fw-regular' style={{ color: '#2A3040' }}><span className='fw-bold text-dark'>Improve billing accuracy</span> with codes tailored to therapy, psychiatry, and counseling
                        </p>
                      </div>
                    </div>
                    <div className="d-flex mt-3 mt-lg-1">
                      <div className='number-bg-img1 one p-lg-3 text-lg-center mt-lg-1 mt-0'></div>
                      <div className="div d-flex align-items-center">
                        <p className='m-0 mt-lg-2 about-first-desc fw-regular' style={{ color: '#2A3040' }}><span className='fw-bold text-dark'>Strengthen compliance</span> with evolving mental health and telehealth regulations
                        </p>
                      </div>
                    </div>
                    <div className="d-flex mt-3 mt-lg-1 mb-lg-0 mb-3">
                      <div className='number-bg-img2 one p-lg-3 text-lg-center mt-lg-0 mt-0'></div>
                      <div className="div d-flex align-items-center">
                        <p className='m-0 mt-lg-2 about-first-desc fw-regular' style={{ color: '#2A3040' }}><span className='fw-bold text-dark'>Streamline administrative workflows</span> so you can focus more on patient care
                        </p>

                      </div>
                    </div>
                    <div className="d-flex mt-2 mt-lg-1 mb-lg-0 mb-3">
                      <div className='number-bg-img3 one p-lg-3 text-lg-center mt-lg-0 mt-0'></div>
                      <div className="div d-flex align-items-center">
                        <p className='m-0 mt-lg-2 about-first-desc fw-regular' style={{ color: '#2A3040' }}><span className='fw-bold text-dark'>Accelerate collections</span>  with faster, cleaner claim processing

                        </p>

                      </div>
                    </div>
                    <div className="d-flex mt-2 mt-lg-2 mb-lg-0 mb-3">
                      <div className='number-bg-img4 one p-lg-3 text-lg-center mt-lg-0 mt-3'></div>
                      <div className="div d-flex align-items-center">
                        <p className='m-0 mt-lg-2 about-first-desc fw-regular' style={{ color: '#2A3040' }}><span className='fw-bold text-dark'>Receive personalized support</span> from billing experts who understand mental health services

                        </p>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section
          className={`pb-md-0 pb-0 px-0 px-md-5 add_border_radius_second bg_light_img_add py-lg-5 animate-section ${animatedSections.has(5) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[5] = el}
          data-section-index="5"
        >
          <div className="container px-2 px-md-0 py-md-4 py-4">
            <div className="row justify-content-center mx-auto">
              <div className='col-12 d-flex align-items-center justify-content-center'>
                <h2 className='mb-md-0 mb-2 d-md-flex d-none align-items-center justify-content-center add_font_head fw-semibold'>
                  Tailored RCM & Billing Services for Every<br /> Mental Health Practice                                </h2>
                <h2 className='mb-md-0 mb-2 d-md-none d-block align-items-center justify-content-center add_font_head fw-semibold mt-0'>
                  Tailored RCM & Billing Services for Every Mental Health Practice                                </h2>
              </div>

              <div className="col-12 mt-md-5 mt-2 px-1 px-md-0">
                <div className="row mx-auto">
                  {practiceSettings.map((item, index) => (
                    <div key={index} className="col-12 col-md-4 mb-md-3 mb-3 d-flex">
                      <div
                        className="w-100 p-md-4 p-3 bg-white shadow-sm rounded-4 position-relative h-100  add_bg_color_card services-hover-effect d-flex flex-column align-items-center justify-content-between"
                        onClick={() => handlePracticeSettingClick(item.title)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="d-flex align-items-center mb-md-3 mb-0 justify-content-between col-12">
                          <img
                            src={item.icon}
                            alt={item.alt}
                            style={{ width: "70px", height: "70px", objectFit: "contain" }}
                            className="me-3 image_width_data_icon_small"
                          />
                          <span className="add_num_font fw-semibold">{item.number}</span>
                        </div>
                        <div className='col-12'>                                                <h3 className="add_font_another mb-0 fw-semibold text-start mt-2">{item.title}</h3>
                        </div>
                        <div className='col-12'>                                                <p className="mb-0 add_font_card_para_data text-start mt-1">{item.description}</p>
                        </div>

                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className={`position-relative animate-section ${animatedSections.has(6) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[6] = el}
          data-section-index="6"
        >
          <img src={dottesti} alt='' className='position-absolute add_set_position' />
          <div className="container mt-lg-0 mt-0 card-bg-vector">
            <div className="row mx-auto mt-lg-4">
              <div className="col-lg-8 col-12 m-0 mt-lg-5 text-start">
                <h2 className=" text-dark text-probill-rcm m-0 mt-lg-0 mt-4 ">Our Positive  <span className="text-probill-rcm-orange add_grident_font">Social Impact</span></h2>
                <p className='mt-lg-3 mt-1 text-probill-para m-0 d-md-block d-none'>Trusted by Healthcare Professionals</p>
                <p className='mt-lg-3 mt-1 text-probill-para m-0 d-block d-md-none'>Trusted by Healthcare Professionals</p>
              </div>
              <div className="col-lg-4 mt-lg-5 col-12 text-lg-end text-center">
                {/* <h5 className='me-0 fw-semibold mb-2' style={{ fontSize: "24px", lineHeight: "40px" }}><img src={onestart} alt="" style={{ width: "27px", height: "27px" }} /> Trustpilot</h5> */}
                <div className="d-flex justify-content-lg-end justify-content-center align-items-end pt-3 pt-md-0">
                  <div className="d-flex justify-content-between ">

                    <div className="div star mx-1 d-flex align-item-center ">
                      <img src={start} className='mx-auto img-fluid' alt="" />
                    </div>
                    <div className="div star mx-1 d-flex align-item-center">
                      <img src={start} className='mx-auto img-fluid' alt="" />
                    </div>
                    <div className="div star mx-1 d-flex align-item-center">
                      <img src={start} className='mx-auto img-fluid' alt="" />
                    </div>
                    <div className="div star mx-1 d-flex align-item-center">
                      <img src={start} className='mx-auto img-fluid' alt="" />
                    </div>
                    <div className="div star mx-1 d-flex align-item-center me-0">
                      <img src={start} className='mx-auto img-fluid' alt="" />
                    </div>

                  </div>
                </div>
                {/* <p className='my-0' style={{ fontSize: "14px", lineHeight: "40px", color: "#474d5cff" }}>Trust Score 5.0 | 3,724 reviews</p> */}
              </div>
            </div>

          </div>
          <div className="container-fluid  mt-lg-0">
            <div className="row mx-auto card-bg-vect">
              <div className="quote-symbol-container px-5" style={{ position: 'absolute', left: 0, top: "0px", zIndex: 0, }}>
                <img src={card_vector} className="quote-symbol" alt="quote" />
                <img src={card_vector} className="quote-symbol" alt="quote" />
              </div>

              <div
                className="container-fluid mt-lg-5 animate-section"
                ref={containerRef}
                style={{ overflow: 'hidden', padding: '20px 0' }}
              >
                <div className="row mx-auto card-bg-vect" style={{ position: 'relative' }}>
                  <div
                    className="d-flex"
                    onMouseEnter={() => setIsAutoPlaying(false)}
                    onMouseLeave={() => setIsAutoPlaying(true)}
                    style={{
                      transform: `translateX(-${currentIndex * CARD_WIDTH}px)`,
                      transition: currentIndex >= testimonials.length ? 'none' : 'transform 0.5s ease-in-out',
                      gap: '16px',
                      willChange: 'transform',
                    }}
                  >
                    {infiniteTestimonials.map((testimonial, index) => (
                      <Card
                        key={`${testimonial.name}-${index}`}
                        className="h-100 slide-card"
                        style={{
                          borderRadius: '20px',
                          minWidth: `${CARD_WIDTH - 16}px`,
                          maxWidth: `${CARD_WIDTH - 16}px`,
                          flexShrink: 0,
                          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        }}
                      >
                        <Card.Body className="d-flex flex-column mt-md-4 mt-0 px-4">
                          <h3 className="text-start m-0 card-heading text-dark">{testimonial.title}</h3>
                          <Card.Text className="text-muted text-start insight-desc flex-grow-1">
                            {testimonial.quote}
                          </Card.Text>
                          <div className="d-flex align-items-center mt-3 mb-3">
                            <img
                              src={testimonial.img}
                              alt={testimonial.name}
                              className="rounded-5 me-3 card-user-img"
                              style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                            />
                            <div className="text-start">
                              <h4 className="mb-0 text-dark m-0 card-user-name">{testimonial.name}</h4>
                              <span className="text-muted mb-0 card-rating">{testimonial.role}</span>
                            </div>
                            <div className="ms-auto mt-2 mx-0 align-items-center">
                              <div className="d-flex align-items-center">
                                <img
                                  src={onestart}
                                  alt="Star"
                                  className="m-0"
                                  style={{ width: '20px', height: '20px' }}
                                />
                                <span
                                  className="ms-1 text-dark m-0"
                                  style={{ fontWeight: '600', fontFamily: 'poppins', fontSize: '16px' }}
                                >
                                  {testimonial.rating}
                                </span>
                              </div>
                              <span className="text-muted card-rating">Rating</span>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ))}
                  </div>
                </div>

                <div className="container mt-lg-5 mt-3">
                  <div className="row mx-auto mb-lg-5 mb-3">
                    <div className="d-flex col-lg-12 col-12 gap-2 align-items-center justify-content-center">
                      <Button
                        onClick={() => {
                          trackEvent('testimonial_navigation', 'Testimonials', 'previous');
                          handlePrev();
                        }}
                        disabled={currentIndex === 0}
                        className="btn fw-bold bg-white rounded-5 text-dark border-white shadow "
                      >
                        <i className="bi bi-arrow-left fw-bold"></i>
                      </Button>
                      <Button
                        onClick={() => {
                          trackEvent('testimonial_navigation', 'Testimonials', 'next');
                          handleNext();
                        }}
                        disabled={currentIndex >= testimonials.length - visibleCards}
                        className="btn bg-white text-dark border-white shadow fw-bold"
                      >
                        <i className="bi bi-arrow-right"></i>
                      </Button>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className={`pb-md-0 pb-0 px-0 px-md-5 position-relative animate-section ${animatedSections.has(7) ? 'visible' : ''}`}
          style={{ background: "#F5F5F5" }}
          ref={el => sectionRefs.current[7] = el}
          data-section-index="7"
        >
          <div className='boost_main_client boost_main_client_two_next position-absolute'>
            <img src={clients} alt='' />
          </div>
          <div className="container px-2 px-md-0 py-md-5 py-4">
            <div className="row justify-content-center mx-auto py-lg-4">


              <div className='col-12 d-flex flex-column align-items-center justify-content-start'>
                <h2 className='mb-0 d-flex align-items-center justify-content-start add_font_head fw-semibold d-md-block d-none'>
                  Comprehensive Mental Health <br />Billing & RCM Services

                </h2>
                <h2 className='mb-0 d-flex align-items-center justify-content-start add_font_head fw-semibold d-block d-md-none mt-0'>
                  Comprehensive Mental Health Billing & RCM Services

                </h2>
                <p className="mb-0 text-dark add_para_font fw-medium d-md-block d-none">
                  We deliver complete{" "}
                  <a
                    href="https://probillrcm.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "inherit", textDecoration: "none", fontWeight: "bold" }}
                  >
                    mental health billing
                  </a>{" "}
                  and RCM solutions to boost revenue,
                  <br /> cut admin tasks, and streamline your practice.
                </p>

                <p className="mb-0 text-dark add_para_font fw-medium d-block d-md-none">
                  We deliver complete{" "}
                  <a
                    href="https://probillrcm.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "inherit", textDecoration: "none", fontWeight: "bold" }}
                  >
                    mental health billing
                  </a>{" "}
                  and RCM solutions to boost revenue, cut admin tasks, and streamline your practice.
                </p>
              </div>

              <div className="col-12 mt-md-4 mt-2 px-0 px-md-0">
                <div className="row mx-auto">
                  {familyMedicineServices.map((service, index) => (
                    <div
                      key={index}
                      className="col-6 col-sm-12 col-md-4 position-relative mb-md-0 mb-0 p-2"
                    >
                      <div className="row h-100 mx-auto">
                        <div
                          className="col py-md-4 py-3 px-md-3 px-0 add_bg_color_card services-hover-effect bg-white shadow-sm"
                          onClick={() => handleServiceClick(service.title)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="row mx-auto">
                            <div className="col-12 d-md-flex d-block align-items-center justify-content-md-start justify-content-center mb-md-3 mb-2 text-start text-md-start">
                              <img
                                src={service.icon}
                                alt={service.alt}
                                loading="lazy"
                                className="mb-0 mb-md-0 add_width_in_icons"
                                style={{
                                  width: "45px",
                                  height: "45px",
                                  objectFit: "contain"
                                }}
                              />
                            </div>
                            <div className="col-12 text-start mb-md-3 mb-2 pe-0">
                              <h3 className="add_font_another mb-0 fw-semibold text-start">
                                {service.title}
                              </h3>
                            </div>
                            <div className="col-12 text-start">
                              <p className="mb-0 add_font_card_para_data">
                                {service.description}
                              </p>
                            </div>
                            {/* <div className="col-12 text-end">
                            <p className="mb-0 add_font_card_para_data d-flex align-items-center justify-content-end add_grident_font fw-bold">
                              Learn More <i className="bi bi-arrow-right-short fs-3 ms-1"></i>
                            </p>
                          </div> */}

                          </div>
                        </div>
                      </div>
                      <img
                        src="/static/media/wire.33ad6b5bff2f03eb7311.webp"
                        alt=""
                        className="add_position_card_img position-absolute"
                        loading="lazy"
                      />
                    </div>
                  ))}

                </div>
              </div>
            </div>
          </div>
        </section>
        <div
          className={`container about_bg_blue my-md-5 my-4 animate-section py-md-4 py-0 ${animatedSections.has(8) ? 'visible' : ''}`}
          style={{ borderRadius: "36px" }}
          ref={el => sectionRefs.current[8] = el}
          data-section-index="8"
        >
          <div className="row mx-auto mt-0 mt-lg-0 py-md-5 py-4">
            <div className="col-lg-8 mx-auto m-0 col-12  mt-0 pb-3 text-lg-center flex-column d-flex justify-content-center">
              <h2 className='text-white contact-text  m-0 mt-lg-0 mt-0 d-md-block d-none'>
                Uncover Mental Health Revenue Gaps with a<br /> Targeted, Data-Driven Analysis            </h2>
              <h3 className='text-white contact-text  m-0 mt-lg-0 mt-0 d-md-none d-block'>
                Uncover Mental Health Revenue Gaps with a Targeted, Data-Driven Analysis            </h3>
              <p className=' any-para mt-3 mt-lg-5 mb-0' style={{ color: 'rgba(255, 255, 255, 1)' }}>Let our team evaluate your financial setup and billing processes. In 95% of mental health practice reviews, we identify missed revenue opportunities.
                This is the first step toward building a more stable, efficient, and connected revenue cycle. Your care is the specialty — our financial expertise makes us the ideal partner.  </p>


            </div>
            <div className='col-12 d-flex align-items-center justify-content-center mt-md-4 mt-2'>
              <button
                className="btn add_padding_font"
                onClick={() => handleCTAClick('revenue_gaps_section')} type="button"
                style={{
                  background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                  color: "white",
                  borderRadius: "12px",
                  padding: "12px 40px",
                  border: "none",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Let’s Connect                           </button>
            </div>


          </div>
        </div>

        <section
          className={`faq-section pb-5 position-relative animate-section ${animatedSections.has(9) ? 'visible' : ''}`}
          ref={el => sectionRefs.current[9] = el}
          data-section-index="9"
        >
          <Container>
            <Row className="align-items-center py-md-4 py-0 mx-auto">
              <Col lg={6} className="d-flex gap-3 justify-content-center flex-wrap ps-lg-5">

                <div className="col-lg-12 m-0 col-12  mt-0  text-lg-start flex-column d-flex justify-content-center">
                  <h2 className='text-black contact-text  m-0 mt-lg-0 mt-2'>
                    Frequently Asked Questions
                  </h2>
                  <p className='any-para mt-3 mt-lg-4 mb-3'>
                    Get expert insights and practical solutions to your most pressing questions about{" "}
                    <a
                      href="https://probillrcm.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "inherit", textDecoration: "none", fontWeight: "bold" }}
                    >
                      mental health billing
                    </a>
                    , revenue cycle management, and practice consulting.
                  </p>
                </div>
              </Col>
              <Col lg={6} className="pe-lg-6 px-3 py-2" style={{ border: "1px solid #c0c3ccff", borderRadius: "12px" }}>
                <div className="accordion" id="accordionExample">

                  <div className="accordion-item border-bottom border-0">
                    <h3 className="accordion-header" id="headingOne">
                      <button className="accordion-button add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        What is Mental Health Touch™ and how does it benefit providers?
                        <span className="accordion-icon ms-auto">
                          <svg className="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                          </svg>
                          <svg className="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                          </svg>
                        </span>
                      </button>
                    </h3>
                    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                      <div className="accordion-body add_custom_font_para px-0">
                        Mental Health Touch™ is an automated clinical record-keeping solution designed for therapists, counselors, and behavioral health providers. It reduces administrative tasks, securely manages patient data, and improves documentation accuracy.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item border-bottom border-0">
                    <h3 className="accordion-header" id="headingTwo">
                      <button className="accordion-button collapsed add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        How can Probill RCM improve my mental health practice’s revenue?
                        <span className="accordion-icon ms-auto">
                          <svg className="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                          </svg>
                          <svg className="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                          </svg>
                        </span>
                      </button>
                    </h3>
                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                      <div className="accordion-body add_custom_font_para px-0">
                        Our RCM experts streamline billing processes, reduce claim denials, and maximize reimbursements through advanced billing analytics, denial management, and customized revenue strategies.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item border-bottom border-0">
                    <h3 className="accordion-header" id="headingThree">
                      <button className="accordion-button collapsed add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        Do you offer EMR integration for mental health practices?
                        <span className="accordion-icon ms-auto">
                          <svg className="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                          </svg>
                          <svg className="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                          </svg>
                        </span>
                      </button>
                    </h3>
                    <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                      <div className="accordion-body add_custom_font_para px-0">
                        Yes, we provide seamless EMR and system integration to ensure accurate data flow, minimize errors, and boost operational efficiency.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item border-0">
                    <h3 className="accordion-header" id="headingFour">
                      <button className="accordion-button collapsed add_custom_font" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        Do you work with both small practices and large healthcare systems?
                        <span className="accordion-icon ms-auto">
                          <svg className="icon-open" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                          </svg>
                          <svg className="icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#F37016" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                          </svg>
                        </span>
                      </button>
                    </h3>
                    <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                      <div className="accordion-body add_custom_font_para px-0">
                        Yes, we offer tailored RCM and billing solutions for private practices, clinics, and large healthcare networks, ensuring scalability and efficiency.
                      </div>
                    </div>
                  </div>

                </div>
              </Col>

            </Row>


          </Container>
          {/* <div class="boost_main_client boost_main_client_tranform position-absolute"><img src={clients} alt="" /></div> */}
          <div class="boost_main_client_right boost_main_client_right_tranform_texti position-absolute"><img src={workright} alt="" /></div>
        </section>
        <Modal show={showModal} onHide={handleClose} centered size='xl'>


          {/* Close Button in Top-Right Corner */}
          <button
            type="button"
            className="btn-close position-absolute"
            style={{
              top: "11px",
              right: "11px",
              zIndex: 1051,
              backgroundColor: "#fff",
              borderRadius: "50%",
              padding: "6px",
              fontSize: "15px",
              // border: "2px solid black",
            }}
            aria-label="Close"
            onClick={handleClose}
          ></button>

          <Modal.Body className="p-4">
            <div className="container-fluid">
              <div className="row d-flex justify-content-center align-items-center">
                <div className="col-lg-6 d-none d-lg-block">
                  <div className="image-container">
                    <img
                      src={external1}
                      alt="Team Working"
                      className="w-100 h-100 diagonal-image"
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 ps-md-4 ps-0">
                  {isSubmitted ? (
                    <div className="text-center">
                      <h1 className="hero-text mt-0">
                        Thank <span className="text-orange add_grident_font" style={{ color: "#E9720E" }}>You!</span> <br />
                      </h1>
                      <p>for submitting your information! Our representative will reach out to you shortly.</p>
                    </div>
                  ) : (
                    <>
                      <div className="d-flex m-0 modal-heading justify-content-between">
                        <h1>
                          How can we <span style={{ color: "#E27239" }}>help you?</span>
                        </h1>
                        {/* Remove this old close button if not needed */}
                        {/* <button
                                          type="button"
                                          className="btn-close d-lg-none d-block"
                                          onClick={handleClose}
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                      ></button> */}
                      </div>
                      <p className="fs-6 m-0 d-lg-none" style={{ color: "#2A3040" }}>
                        Within 24 hours, a representative from our company will contact you.
                      </p>
                      <form onSubmit={handleSubmit(onSubmit)} className="mt-0">
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-medium text-start d-block">Name</label>
                            <input
                              type="text"
                              placeholder="Enter your Full Name"
                              className={`custom_control py-2 form-control ${errors.fullName ? "is-invalid" : ""}`}
                              style={{ border: "1px solid #A4A4A480", height: "48px" }}
                              {...register("fullName", { required: "Full Name is required" })}
                            />
                            {errors.fullName && (
                              <p className="text-danger">{errors.fullName.message}</p>
                            )}
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label fw-medium text-start d-block">Email</label>
                            <input
                              type="email"
                              placeholder="Enter your Email"
                              className={`custom_control py-2 form-control ${errors.email ? "is-invalid" : ""}`}
                              style={{ border: "1px solid #A4A4A480", height: "48px" }}
                              {...register("email", {
                                required: "Email is required",
                                pattern: {
                                  value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                  message: "Please enter a valid email address"
                                }
                              })}
                            />
                            {errors.email && (
                              <p className="text-danger">{errors.email.message}</p>
                            )}
                          </div>

                          <div className="col-md-12 mb-3">
                            <label className="form-label fw-medium text-start d-block">Subject</label>
                            <input
                              type="text"
                              placeholder="Enter Subject"
                              className={`custom_control py-2 form-control ${errors.subject ? "is-invalid" : ""}`}
                              style={{ border: "1px solid #A4A4A480", height: "48px" }}
                              {...register("subject", {
                                required: "Subject is required",
                                minLength: {
                                  value: 3,
                                  message: "Subject should be at least 3 characters long"
                                }
                              })}
                            />
                            {errors.subject && (
                              <p className="text-danger">{errors.subject.message}</p>
                            )}
                          </div>

                          <div className="col-md-12 mb-3">
                            <label className="form-label fw-medium text-start d-block">Message</label>
                            <textarea
                              className={`custom_control py-2 form-control ${errors.message ? "is-invalid" : ""}`}
                              style={{ border: "1px solid #A4A4A480" }}
                              rows="7"
                              placeholder="Brief us on your requirements"
                              {...register("message", {
                                required: "Message is required",
                                minLength: {
                                  value: 10,
                                  message: "Message should be at least 10 characters long"
                                }
                              })}
                            ></textarea>
                            {errors.message && (
                              <p className="text-danger">{errors.message.message}</p>
                            )}
                          </div>

                          <div className="col-md-12 mt-3">
                            <button
                              type="submit"
                              className="btn col-12"
                              style={{
                                background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                                color: "white",
                                borderRadius: "12px",
                                padding: "12px 24px",
                                border: "none",
                                fontWeight: "500",
                                fontSize: "16px"
                              }}
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? "SENDING..." : "Submit Now"}
                            </button>
                          </div>
                        </div>
                      </form>
                    </>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>

        </Modal>
      </section>
    </>
  );
};

export default MentalHealth;
